import "./SeasonalCare.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import BespokePeptideSynthesis from "./sections/BespokePeptideSynthesis";
import The48HourJourney from "./sections/The48HourJourney";
import BusinessSuccession from "./sections/BusinessSuccession";
import Footer from "@/reusable_sections/Footer";
export default function SeasonalCarePage() {
  return <div>
      <FraternalExcellenceHeader />
      <BespokePeptideSynthesis />
      <The48HourJourney />
      <BusinessSuccession />
      <Footer />
    </div>;
}